export default __webpack_public_path__ + "static/media/twitter.f245fca6.svg";